var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dots"},_vm._l((_vm.getDecisionCount),function(dot,i){return _c('div',{key:i,staticClass:"circle",class:{ filled: i <= _vm.getDecisionRound }})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }